import React, { useEffect, useState, useRef } from 'react'
import styles from './header.module.css'
import Navbar from '../Navbar/Navbar'
import { Cart, Location, Profile, Topdropdown } from '../../../../Svg'
import { useLocation, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import api from '../../../utils/api'
import { stripHtmlTags } from '../../../utils/utils'
import { Bell } from 'lucide-react'

const Header = () => {
    const { customer, refresh, loading, isLoggedin } = useSelector((state) => state.customer)
    const { notificationCountData } = useSelector((state) => state.notification)
    const navigate = useNavigate();
    const location = useLocation();
    const isHomePage = location.pathname === "/";
    const [scrolled, setScrolled] = useState(false);
    
    // Header search states
    const [search, setSearch] = useState('')
    const [suggestedData, setSuggestedData] = useState([])
    const searchRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchRef.current && !searchRef.current.contains(event.target)) {
                setSuggestedData([]);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        const getHeroThreshold = () => {
            const heroSearchEl = document.querySelector('[class*="searchWrapper"]');
            if (heroSearchEl) {
                const rect = heroSearchEl.getBoundingClientRect();
                return window.scrollY + rect.bottom;
            }
            return 380;
        };

        const handleScroll = () => {
            const threshold = isHomePage ? getHeroThreshold() : 0;
            if (window.scrollY > threshold) {
                setScrolled(true);
            } else {
                setScrolled(false);
                setSuggestedData([]);
            }
        };

        handleScroll();
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [isHomePage]);

    const searchCategory = (e) => {
        if (e) e.preventDefault()
        setSuggestedData([])
        if (search && search.trim()) {
            navigate(`/categories?search=${encodeURIComponent(search.trim())}`)
        }
    }

    const latestQueryRef = useRef('');
    const debounceTimerRef = useRef(null);

    const smartSearch = (text) => {
        setSearch(text);
        latestQueryRef.current = text;
        if (!text.trim()) {
            if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
            setSuggestedData([]);
            return;
        }
        if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
        debounceTimerRef.current = setTimeout(async () => {
            const currentQuery = text.trim();
            try {
                const response = await api.smartSearch(`?query=${encodeURIComponent(currentQuery)}&limit=15`);
                if (response.data && latestQueryRef.current.trim() === currentQuery) {
                    setSuggestedData(response.data?.data?.results || []);
                }
            } catch (err) {
                console.log(err);
            }
        }, 180);
    };

    const getCleanUrl = (url) => {
        if (!url) return '';
        if (url.includes('asset.electrowiz.in')) {
            return url.replace('https://asset.electrowiz.in', 'https://electrowiz-ap.s3.ap-south-1.amazonaws.com');
        }
        return url;
    };

    const handlecatclick = (data) => {
        setSuggestedData([])
        if (data?.type === "level3") {
            navigate(`/productList/${data?.name}`)
        } else {
            navigate(`/categories?search=${encodeURIComponent(data?.name)}`)
        }
    }

    const showHeaderSearch = !isHomePage || scrolled;

    return (
        <div className={`${styles.headerContainer} ${(scrolled || !isHomePage) ? styles.scrolled : ""}`}>
            <div className={styles.headerRow2}>
                <div className={styles.headLogo} onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
                    <img src='/assets/logo.png' alt="Electrowiz Logo" />
                </div>
                
               
                    {showHeaderSearch && (<form ref={searchRef} onSubmit={searchCategory} className={styles.headerSearchContainer}>
                        <div className={styles.inputWrapper}>
                            <span className={styles.headerSearchIcon}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <circle cx="11" cy="11" r="8"></circle>
                                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                                </svg>
                            </span>
                            <input
                                type="text"
                                placeholder="Search parts, manufacturers..."
                                className={styles.headerSearchInput}
                                value={search}
                                onChange={(e) => smartSearch(e.target.value)}
                            />
                        </div>

                        
                        {suggestedData.length > 0 && (
                            <div className={styles.headerSearchBox}>
                                <ul>
                                    {suggestedData.map((i, index) => (
                                        <React.Fragment key={index}>
                                            {i?.type !== "product" ? (
                                                <li onClick={() => handlecatclick(i)}>
                                                    <span className={styles.headerSuggestionIcon}>📦</span>
                                                    <div className={styles.headerSuggestionMeta}>
                                                        <span className={styles.headerSuggestionTitle}>{i?.name}</span>
                                                    </div>
                                                </li>
                                            ) : (
                                                <li onClick={() => navigate(`/ProductCode/${i?.name}`)}>
                                                    {i?.image ? (
                                                        <img src={getCleanUrl(i.image)} alt={i.name} className={styles.headerSuggestionImage} />
                                                    ) : (
                                                        <span className={styles.headerSuggestionIcon}>⚡</span>
                                                    )}
                                                    <div className={styles.headerSuggestionMeta}>
                                                        <span className={styles.headerSuggestionTitle}>
                                                            Part: {i?.name}{i?.manufacturer?.[0]?.name ? ` | ${i.manufacturer[0].name}` : ''}
                                                        </span>
                                                        {i?.description && (
                                                            <span className={styles.headerSuggestionDescription}>
                                                                {stripHtmlTags(i.description)}
                                                            </span>
                                                        )}
                                                    </div>
                                                </li>
                                            )}
                                        </React.Fragment>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </form>
                )}
                
                <div className={styles.headLangAndIcons}>
                    
                    <div className={styles.headLang}>
                        <div>
                            <span>₹ INR</span>
                            <Topdropdown />
                        </div>
                        {isLoggedin === true ? (
                            <div className={styles.userName} onClick={() => navigate('/myprofile')}>
                                {customer?.fullName}
                            </div>
                        ) : (
                            <div onClick={() => navigate('/login')} className={styles.loginBtn}>
                                <span>Sign In</span>
                            </div>
                        )}
                    </div>

                  
                    <div className={styles.headIcons}>
                        

                        {isLoggedin === true && (
                            <div onClick={() => navigate('/userNotifications')} className={styles.iconBtn}>
                                <Bell size={20} color="#ffffff" strokeWidth={2.2} />
                                {notificationCountData > 0 && (
                                    <div className={styles.badge}>
                                        {notificationCountData}
                                    </div>
                                )}
                            </div>
                        )}
                        
                        <div onClick={() => navigate('/cart')} className={styles.iconBtn}>
                            <img src='/assets/shoppingcart.png' alt="Cart" />
                            {customer?.unreadCartCount > 0 && (
                                <div className={styles.badge}>
                                    {customer?.unreadCartCount}
                                </div>
                            )}
                        </div>
                        
                        <div onClick={() => navigate('/scheduleCart')} className={styles.iconBtn}>
                            <img src='/assets/schedulecart.png' alt="Schedule Cart" />
                            {customer?.unreadScheduleCount > 0 && (
                                <div className={styles.badge}>
                                    {customer?.unreadScheduleCount}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <Navbar />
        </div>
    )
}

export default Header
